import { render, staticRenderFns } from "./BaronITSolutions.vue?vue&type=template&id=246adef3&scoped=true"
import script from "./BaronITSolutions.vue?vue&type=script&lang=js"
export * from "./BaronITSolutions.vue?vue&type=script&lang=js"
import style0 from "./BaronITSolutions.vue?vue&type=style&index=0&id=246adef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246adef3",
  null
  
)

export default component.exports